import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { ChangeViewIcon } from '../icons';

export const ViewChangeButton = ({
  handleViewChange,
}: {
  handleViewChange: (value: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChooseOption = (onClick: () => void) => {
    handleClose();
    onClick();
  };

  const options = [
    {
      icon: <i className="fa-regular fa-gallery-thumbnails" style={{ marginRight: '16px' }} />,
      label: 'Band View',
      onClick: () => handleViewChange('band'),
    },
    {
      icon: <i className="fa-regular fa-grid-2" style={{ marginRight: '16px' }} />,
      label: 'Grid View',
      onClick: () => handleViewChange('grid'),
    },
  ];

  return (
    <>
      <Button
        id="menu-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={<ChangeViewIcon />}
        variant="contained"
        sx={{
          height: '44px',
          boxShadow: 'none',
          borderRadius: '8px',
          background: 'rgba(0, 0, 0, 0.40)',
          backdropFilter: 'blur(20px)',
          maxWidth: '155px',
          '&:hover': {
            color: '#fff',
            background: 'rgba(0, 0, 0, 0.40)',
            boxShadow: 'none',
          },
        }}
      >
        View Modes
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'menu-button',
        }}
        PaperProps={{
          style: {
            color: 'white',
            background: 'rgba(0, 0, 0, 0.40)',
            backdropFilter: 'blur(40px)',
            borderRadius: '6px',
            pointerEvents: 'all',
          },
        }}
      >
        {options?.map((option, i) => {
          return (
            <MenuItem key={i} onClick={() => handleChooseOption(option.onClick)} sx={{ '&:hover': { background: 'rgba(0, 0, 0, 0.40)' } }}>
              {option.icon}
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
